import { render, staticRenderFns } from "./ModalDepreciableAssets.vue?vue&type=template&id=10b85313"
import script from "./ModalDepreciableAssets.vue?vue&type=script&lang=js"
export * from "./ModalDepreciableAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports